import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import moment from 'moment'

import { Label } from 'atoms/Texts'
import { FormSelect } from 'atoms/Inputs'
import { ButtonReg } from 'atoms/Buttons'
import IconPng from 'atoms/IconPng'
import { statusBtnFormatter, actionFormatter } from 'molecules/TableFormatters'
import DataTables from 'organisms/DataTable'

import { toggleIsLoading } from 'Redux/actions/ViewStateActions'
import { getAllHistoryDataValidation } from 'Redux/actions/DataValidationActions'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import {
  RoundedWrapper,
  FilterCol,
  FilterRow,
  StyledDatePicker,
  HyphenWrapper,
} from './styles'
import { withTheme } from 'styled-components'
import { ValidationDataTypes } from 'fixtures/enums'

const ic_eye = require('App/assets/images/ic_eye.png')
const ic_restart = require('App/assets/vectors/ic_restart.svg')

class HistoryDataValidation extends Component {
  constructor(props) {
    super(props)
    this.state = {
      filters: {
        companyId: {
          name: 'Company',
          value: props.user.originCompanyId || '-',
          lookup: [],
          valField: 'id',
          dispField: 'name',
        },
        startDate: {
          name: 'Transaction Date',
          type: 'date',
          value: this.getFirstDate(),
        },
        endDate: {
          type: 'date',
          value: new Date(),
        },
        dataType: {
          name: 'Data',
          value: '-',
          lookup: [
            {
              value: '',
              label: 'All',
            },
            ...ValidationDataTypes.filter(
              (d) =>
                props.user &&
                !!d.permissions &&
                props.user.permissions.includes(d.permissions)
            ),
          ],
        },
        validationStatus: {
          name: 'Validation Status',
          value: '-',
          lookup: [
            {
              value: '',
              label: 'All',
            },
            {
              value: 'not_validated',
              label: 'Not Validated',
            },
            {
              value: 'partially_validated',
              label: 'Partially Validated',
            },
            {
              value: 'validated',
              label: 'Validated',
            },
          ],
        },
      },
      dataList: [],
    }
  }

  componentDidMount() {
    this.props.toggleIsLoading(true)
    this.getSavedFilters()
  }

  componentDidUpdate(prevProps) {
    const {
      companies,
      historyDataValidationList,
      viewState: { isLoading },
    } = this.props
    const { filters } = this.state
    if (isLoading) {
      const obj = Object.assign(filters)

      filters['companyId'].lookup = companies

      this.setState({ filters: obj }, () => {
        this.props.toggleIsLoading(false)
      })
    }

    if (prevProps.historyDataValidationList !== historyDataValidationList) {
      this.setState({ dataList: historyDataValidationList })
    }
  }

  buildParams() {
    const filterObj = Object.entries(this.state.filters)
    let params = []
    for (const [key, filter] of filterObj) {
      if (filter.type === 'date') {
        params.push(`${key}=${moment(filter.value).format('YYYY-MM-DD')}`)
      } else if (filter.value === '-') {
        params.push(`${key}=`)
      } else params.push(`${key}=${filter.value}`)
    }
    return params.join('&')
  }

  refreshTable() {
    const params = this.buildParams()
    this.props.getAllHistoryDataValidation(params)
  }

  refreshFilter() {
    window.sessionStorage.removeItem('dataValidationFilters')
    const { filters } = this.state
    for (let key in filters) {
      filters[key].value =
        filters[key].type === 'date'
          ? filters[key].name
            ? this.getFirstDate()
            : new Date()
          : '-'
    }
    filters['companyId'].value = this.props.user.originCompanyId || '-'
    this.setState({ filters: filters }, () => {
      this.refreshTable()
    })
  }

  getFirstDate() {
    const todayDate = new Date()
    return new Date(todayDate.getFullYear(), todayDate.getMonth(), 1)
  }

  getSavedFilters() {
    if (window.sessionStorage.getItem('dataValidationFilters') !== null) {
      let filtersObj = JSON.parse(
        window.sessionStorage.getItem('dataValidationFilters')
      )
      filtersObj.startDate.value = new Date(filtersObj.startDate.value)
      filtersObj.endDate.value = new Date(filtersObj.endDate.value)
      filtersObj.dataType.lookup = [
        {
          value: '',
          label: 'All',
        },
        ...ValidationDataTypes.filter(
          (d) =>
            this.props.user &&
            !!d.permissions &&
            this.props.user.permissions.includes(d.permissions)
        ),
      ]
      this.setState({ filters: filtersObj }, () => {
        this.refreshTable()
      })
    } else this.refreshTable()
  }

  onFilterChange(val, key) {
    const filterObj = Object.assign(this.state.filters)
    filterObj[key].value = val
    this.setState({ filters: filterObj })
  }

  renderFilterRow() {
    const inputConfig = {
      border: this.props.theme.mocaGrey,
      rad: '6px',
      width: 'auto',
      yxPadding: '9px 12px',
      height: '34px',
      arrowSize: '16px',
      arrowPos: 'calc(100% - 12px)',
    }
    const { filters } = this.state

    return (
      <FilterRow pb={10}>
        {Object.entries(filters).map(([key, value]) => (
          <>
            <FilterCol key={key}>
              <Label
                lineheight={'14px'}
                size={'12px'}
              >
                {value.name}
              </Label>
              {value.type === 'date' ? (
                <StyledDatePicker
                  format="dd - MMM - yyyy"
                  onChange={(date) => this.onFilterChange(date, key)}
                  value={value.value}
                />
              ) : (
                <FormSelect
                  placeholder={`Select ${value.name}`}
                  onChangeVal={(e) => this.onFilterChange(e.target.value, key)}
                  value={value.value}
                  options={value.lookup}
                  valField={value.valField ? value.valField : 'value'}
                  dispField={value.dispField ? value.dispField : 'label'}
                  {...inputConfig}
                />
              )}
            </FilterCol>
            {value.type && value.name ? <HyphenWrapper>-</HyphenWrapper> : ''}
          </>
        ))}
        <ButtonReg
          btnTxt={
            <IconPng
              srcIcon={ic_eye}
              ml={'0'}
              mb={'3px'}
              size={'auto'}
              h={'13'}
              showPointer={true}
            />
          }
          rad={'6px'}
          disabled={false}
          width={'34px'}
          height={'34px'}
          onClick={this.refreshTable.bind(this)}
        />
        <ButtonReg
          btnTxt={
            <IconPng
              srcIcon={ic_restart}
              ml={'0'}
              mb={'3px'}
              size={'auto'}
              h={'18'}
              showPointer={true}
            />
          }
          rad={'6px'}
          disabled={false}
          width={'34px'}
          height={'34px'}
          onClick={this.refreshFilter.bind(this)}
          transparent={true}
          bordered={true}
        />
      </FilterRow>
    )
  }

  onOpenDetail(row) {
    const {
      match: { url },
    } = this.props
    window.sessionStorage.setItem(
      'dataValidationFilters',
      JSON.stringify(this.state.filters)
    )
    window.sessionStorage.setItem('dataValidationRow', JSON.stringify(row))
    return `${url}/detail-data-validation`
  }

  render() {
    const { theme } = this.props
    const { dataList } = this.state

    const tableConfig = [
      {
        dataField: 'date',
        headerStyle: { width: 120 },
        text: 'Transaction Date',
        sort: true,
        formatter: (cell, row, rowIndex, formatExtraData) => {
          return (
            <div>{moment(row[formatExtraData]).format('DD - MMM - YYYY')}</div>
          )
        },
        formatExtraData: 'date',
      },
      {
        dataField: 'dataType',
        headerStyle: { width: 50 },
        text: 'Data',
        sort: true,
        formatter: (cell, row, rowIndex, formatExtraData) => {
          const dataType = ValidationDataTypes.find(
            (item) => item.value === row[formatExtraData]
          )
          return <div>{dataType ? dataType.label : ''}</div>
        },
        formatExtraData: 'dataType',
      },
      {
        dataField: 'user',
        headerStyle: { width: 120 },
        text: 'User',
        sort: true,
      },
      {
        dataField: 'validator',
        headerStyle: { width: 100 },
        text: 'Validator',
        sort: true,
        formatter: (cell, row, rowIndex, formatExtraData) => {
          return <div>{row[formatExtraData].join(', ')}</div>
        },
        formatExtraData: 'validator',
      },
      {
        dataField: 'validationStatus',
        headerStyle: { width: 150 },
        text: 'Status Validation',
        sort: true,
        formatter: statusBtnFormatter,
        formatExtraData: {
          field: 'validationStatus',
          type: 'Data Validation',
          auto: true,
          theme,
        },
      },
      {
        dataField: 'mmStatus',
        headerStyle: { width: 100 },
        text: 'Status MM',
        sort: true,
        formatter: statusBtnFormatter,
        formatExtraData: {
          field: 'mmStatus',
          type: 'Data Validation',
          auto: true,
          theme,
        },
      },
      {
        dataField: 'lastModified',
        headerStyle: { width: 150 },
        text: 'Last Modified',
        sort: true,
        formatter: (cell, row, rowIndex, formatExtraData) => {
          return (
            <div>
              {moment(row[formatExtraData]).format('DD - MMM - YYYY HH:mm')}
            </div>
          )
        },
        formatExtraData: 'lastModified',
      },
      {
        dataField: 'action',
        headerStyle: { width: 50 },
        text: 'Action',
        formatter: actionFormatter,
        formatExtraData: {
          detailBtn: true,
          detailUrl: (row) => this.onOpenDetail.bind(this, row),
        },
      },
    ]

    return (
      <RoundedWrapper>
        {this.renderFilterRow()}
        <DataTables
          dataList={dataList ? dataList : []}
          columnConfig={tableConfig}
          leftSlot={<></>}
          defaultSize={10}
          sizePerPageList={[10, 25, 30, 50, 100]}
        />
      </RoundedWrapper>
    )
  }
}

const mapStateToProps = (state) => {
  const userDetail = state.userLogin ? state.userLogin.userDetail : null
  return {
    viewState: state.viewState,
    companies: userDetail ? userDetail.allowedCompanies : [],
    historyDataValidationList: state.historyDataValidationList,
    globals: state.globals,
    user: userDetail,
  }
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      toggleIsLoading,
      getAllHistoryDataValidation,
    },
    dispatch
  )

export default withRouter(
  withTheme(connect(mapStateToProps, mapDispatchToProps)(HistoryDataValidation))
)
